import { render, staticRenderFns } from "./CandidateDetail.vue?vue&type=template&id=02797faa"
import script from "./CandidateDetail.vue?vue&type=script&lang=js"
export * from "./CandidateDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports